var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header row"},[_c('div',{staticClass:"content-header-left col-xs-12 mb-1"},[_c('h2',{staticClass:"content-header-title"},[_vm._v(_vm._s(_vm.title)+" "),_vm._t("additional-header-info")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }